import React from 'react';
import * as appHelpers from '@src/services/helpers/appHelpers';
import { Pathname } from '@src/types/Browsing';
import { useQueryCollections } from '@src/queries/collections/useQueryCollections';
import { PerfectScrollbar } from '../../../../components/PerfectScrollbar';
import { CollectionThumbCircle } from '../CollectionThumbCircle';

export function CollectionBar() {
  const { data: collections } = useQueryCollections();

  if (!collections) {
    return null;
  }

  return (
    <PerfectScrollbar
      id="collection-bar"
      options={{
        wheelSpeed: 0.6,
        minScrollbarLength: 30,
        maxScrollbarLength: 120,
        useBothWheelAxes: true,
        suppressScrollY: true,
      }}
    >
      <div>
        {collections.map((collection) => (
          <div className="collection-container" key={collection._id}>
            <CollectionThumbCircle
              collection={collection}
              onClick={() => appHelpers.setRoute(`/collections/${collection._id}` as Pathname)}
              backgroudImageUrl={collection.preview_media_url ?? undefined}
            />
          </div>
        ))}
      </div>
    </PerfectScrollbar>
  );
}
